module.exports = __webpack_public_path__ + "img/market-participants-ru.522cd18d.png";